import { CardContainer } from './Card.styled.jsx';
import React from 'react';
const Card = ({
    children,
    border,
    week,
    onClick,
    mobileMargin,
    mobileMaxWidth,
    mbMarginBottom,
    background,
    isHideBoxShadow,
    justifyContent,
    height,
    width,
    backgroundColor,
    boxShadow,
    borderRadius,
    padding,
    selected,
    margin,
    cursor,
    shippingMinHeight,
    isShippingCard,
    onCardClick,
    minWidth,
    maxWidth,
    id,
    ...rest
}) => {
    return (
        <CardContainer
        id = {id}
        minWidth = {minWidth}
        maxWidth = {maxWidth}
            border={border}
            weekView={week}
            onClick={isShippingCard ? onCardClick : onClick}
            mobileMargin={mobileMargin}
            mobileMaxWidth={mobileMaxWidth}
            mbMarginBottom={mbMarginBottom}
            background={background}
            isHideBoxShadow={isHideBoxShadow}
            justifyContent={justifyContent}
            height={height}
            width={width}
            backgroundColor={backgroundColor}
            boxShadow={boxShadow}
            borderRadius={borderRadius}
            padding={padding}
            selected={selected}
            margin={margin}
            cursor={cursor}
            shippingMinHeight={shippingMinHeight}
            {...rest}
        >
            {children}
        </CardContainer>
    );
};
Card.defaultProps = {
    children: <></>,
    height: '100%',
    width: '100%',
    backgroundColor: '#ffffff',
    boxShadow: ' 0px 0px 6px #00000029',
    border: 'none',
    borderRadius: '6px',
    padding: '0px',
    selected: false,
    onCardClick: () => {},
};

export default Card;
